<template>
  <div id="home">
    <div class="homeWrap">
      <div class="logoTitle"  v-if="false">
        <p><strong>中国足球协会信息化平台教练员培训管理系统</strong></p>
      </div>
      <div class="moduleWrap">
        <div class="moduleUp">
          <router-link class="linkA" to="/system/class_application" v-if="isFive">
            <div class="moduleItem classItem">
              <div class="icon">
                <v-icon name="clipboard-check" scale="3.5"></v-icon>
              </div>
              <p>开班申请</p>
              <div class="tips"
                v-if="Number(classApplicationNum) > 0">
                <div class="icon">
                  <v-icon name="comment-alt" scale="2"></v-icon>
                </div>
                <div class="num">
                  <span>{{classApplicationNum | filterNum}}</span>
                </div>
              </div>
            </div>
          </router-link>
          <router-link class="linkA" to="/system/class">
            <div class="moduleItem classItem">
              <div class="icon">
                <v-icon name="users-cog" scale="3.5"></v-icon>
              </div>
              <p v-if="isFive">培训班管理</p>
              <p v-else>线下培训班管理</p>
              <div class="tips" v-if="Number(classNum) > 0">
                <div class="icon">
                  <v-icon name="comment-alt" scale="2"></v-icon>
                </div>
                <div class="num">
                  <span>{{ classNum | filterNum }}</span>
                </div>
              </div>
            </div>
          </router-link>
          <router-link class="linkA" to="/system/education_train_list" v-if="!isFive">
            <div class="moduleItem">
              <div class="icon">
                <v-icon name="users-cog" scale="4"></v-icon>
              </div>
              <p>线上继续教育</p>
            </div>
          </router-link>
          <router-link class="linkA" to="/system/class_score_list">
            <div class="moduleItem classItem">
              <div class="icon">
                <v-icon name="file-signature" scale="3.5"></v-icon>
              </div>
              <p>成绩管理</p>
              <div class="tips" v-if="Number(classScoreNum) > 0">
                <div class="icon">
                  <v-icon name="comment-alt" scale="2"></v-icon>
                </div>
                <div class="num">
                  <span>{{ classScoreNum | filterNum }}</span>
                </div>
              </div>
            </div>
          </router-link>
          <router-link class="linkA" to="/system/feedback" v-if="!isFive">
            <div class="moduleItem classItem">
              <div class="icon">
                <v-icon name="check" scale="3.5"></v-icon>
              </div>
              <p style="font-size:19px">培训班投诉/申诉</p>
              <div class="tips" v-if="Number(appeal) > 0 || Number(complaint) > 0 || Number(otherComplaint) > 0">
                <div class="icon">
                  <v-icon name="comment-alt" scale="2"></v-icon>
                </div>
                <div class="num">
                  <span>{{ appeal+complaint+otherComplaint | filterNum }}</span>
                </div>
              </div>
            </div>
          </router-link>
          <router-link class="linkA" to="/system/eva">
            <div class="moduleItem">
              <div class="icon">
                <v-icon name="regular/file-alt" scale="3.5"></v-icon>
              </div>
              <p>调查详情</p>
            </div>
          </router-link>

        </div>
        <div class="moduleDown">
          <router-link class="linkA" to="/system/org">
            <div class="moduleItem">
              <div class="icon">
                <v-icon name="sitemap" scale="4"></v-icon>
              </div>
              <p>培训机构管理</p>
            </div>
          </router-link>
          <router-link class="linkA" to="/system/tea">
            <div class="moduleItem">
              <div class="icon">
                <v-icon name="chalkboard-teacher" scale="4"></v-icon>
              </div>
              <p>讲师管理</p>
            </div>
          </router-link>
          <router-link class="linkA" to="/system/stu">
            <div class="moduleItem">
              <div class="icon">
                <v-icon name="user-cog" scale="4"></v-icon>
              </div>
              <p>学员管理</p>
            </div>
          </router-link>
          <router-link
            class="linkA"
            :to="{ path: 'tutorial_other', query: { res_type: 0 } }"
          >
            <div class="moduleItem">
              <div class="icon">
                <v-icon name="clipboard-list" scale="3"></v-icon>
              </div>
              <p>教案管理</p>
            </div>
          </router-link>
        </div>
        <!--<div class="module-item"  v-if="!isFive">-->
          <!--<div class="item-wrapper">-->
            <!--<div class="hover-box-hide">-->
              <!--<div class="moduleItem">-->
                <!--<div class="icon">-->
                  <!--<v-icon name="user-check" scale="4"></v-icon>-->
                <!--</div>-->
                <!--<p>资质确认</p>-->
                <!--<div class="tips" v-if="Number(confirmInfo) > 0 || Number(qualification)>0">-->
                  <!--<div class="icon">-->
                    <!--<v-icon name="comment-alt" scale="2"></v-icon>-->
                  <!--</div>-->
                  <!--<div class="num">-->
                    <!--<span>{{ (confirmInfo + qualification) | filterNum }}</span>-->
                  <!--</div>-->
                <!--</div>-->
              <!--</div>-->
            <!--</div>-->
            <!--<div class="hover-box-show">-->
              <!--<router-link class="linkA" to="/system/confirmInfo">-->
                <!--<div class="moduleItem">-->
                  <!--<div class="icon">-->
                    <!--<v-icon name="list-alt" scale="4"></v-icon>-->
                  <!--</div>-->
                  <!--<p>信息审核</p>-->
                  <!--<div class="tips" v-if="Number(confirmInfo) > 0">-->
                    <!--<div class="icon">-->
                      <!--<v-icon name="comment-alt" scale="2"></v-icon>-->
                    <!--</div>-->
                    <!--<div class="num">-->
                      <!--<span>{{ confirmInfo | filterNum }}</span>-->
                    <!--</div>-->
                  <!--</div>-->
                <!--</div>-->
              <!--</router-link>-->
              <!--<router-link class="linkA" to="/system/qualification">-->
                <!--<div class="moduleItem">-->
                  <!--<div class="icon">-->
                    <!--<v-icon name="user-check" scale="4"></v-icon>-->
                  <!--</div>-->
                  <!--<p>资质审核</p>-->
                  <!--<div class="tips" v-if="Number(qualification) > 0">-->
                    <!--<div class="icon">-->
                      <!--<v-icon name="comment-alt" scale="2"></v-icon>-->
                    <!--</div>-->
                    <!--<div class="num">-->
                      <!--<span>{{ qualification | filterNum }}</span>-->
                    <!--</div>-->
                  <!--</div>-->
                <!--</div>-->
              <!--</router-link>-->
            <!--</div>-->
          <!--</div>-->
          <!--<div class="item-wrapper">-->
            <!--<router-link class="linkA" to="/system/org_alter_list">-->
              <!--<div class="moduleItem">-->
                <!--<div class="icon">-->
                  <!--<v-icon name="user-plus" scale="4"></v-icon>-->
                <!--</div>-->
                <!--<p>注册管理</p>-->
              <!--</div>-->
            <!--</router-link>-->
            <!--<router-link v-if="!isFive" class="linkA" to="/display">-->
              <!--<div class="moduleItem">-->
                <!--<div class="icon">-->
                  <!--<v-icon name="html5-c" scale="3.5"></v-icon>-->
                <!--</div>-->
                <!--<p>大数据</p>-->
              <!--</div>-->
            <!--</router-link>-->
          <!--</div>-->
        <!--</div>-->
        <div class="moduleDown" v-if="!isFive">
          <router-link class="linkA" to="/system/confirmInfo">
            <div class="moduleItem">
              <div class="icon">
                <v-icon name="list-alt" scale="4"></v-icon>
              </div>
              <p>信息审核</p>
              <div class="tips" v-if="Number(confirmInfo) > 0">
                <div class="icon">
                  <v-icon name="comment-alt" scale="2"></v-icon>
                </div>
                <div class="num">
                  <span>{{ confirmInfo | filterNum }}</span>
                </div>
              </div>
            </div>
          </router-link>
          <router-link class="linkA" to="/system/qualification">
            <div class="moduleItem">
              <div class="icon">
                <v-icon name="user-check" scale="4"></v-icon>
              </div>
              <p>资质审核</p>
              <div class="tips" v-if="Number(qualification) > 0">
                <div class="icon">
                  <v-icon name="comment-alt" scale="2"></v-icon>
                </div>
                <div class="num">
                  <span>{{ qualification | filterNum }}</span>
                </div>
              </div>
            </div>
          </router-link>
          <router-link class="linkA" to="/system/blacklist">
            <div class="moduleItem">
              <div class="icon">
                <v-icon name="user-cog" scale="4"></v-icon>
              </div>
              <p>处罚管理</p>
              <div class="tips" v-if="Number(punishPeople) > 0 || Number(peopleAppeal) > 0">
                <div class="icon">
                  <v-icon name="comment-alt" scale="2"></v-icon>
                </div>
                <div class="num">
                  <span>{{ punishPeople+peopleAppeal | filterNum }}</span>
                </div>
              </div>
            </div>
          </router-link>
          <router-link class="linkA" to="/system/org_alter_list">
            <div class="moduleItem">
              <div class="icon">
                <v-icon name="user-plus" scale="4"></v-icon>
              </div>
              <p>注册管理</p>
              <div class="tips" v-if="Number(reconsider) > 0">
                <div class="icon">
                  <v-icon name="comment-alt" scale="2"></v-icon>
                </div>
                <div class="num">
                  <span>{{ reconsider | filterNum }}</span>
                </div>
              </div>
            </div>
          </router-link>
          <router-link class="linkA" to="/display">
            <div class="moduleItem">
              <div class="icon">
                <v-icon name="html5-c" scale="3.5"></v-icon>
              </div>
              <p>大数据</p>
            </div>
          </router-link>
        </div>
        <div class="moduleDown" v-if="isFive">
          <router-link class="linkA" to="/system/qualification">
            <div class="moduleItem">
              <div class="icon">
                <v-icon name="user-check" scale="4"></v-icon>
              </div>
              <p>资质审核</p>
              <div class="tips" v-if="Number(qualification) > 0">
                <div class="icon">
                  <v-icon name="comment-alt" scale="2"></v-icon>
                </div>
                <div class="num">
                  <span>{{ qualification | filterNum }}</span>
                </div>
              </div>
            </div>
          </router-link>
          <router-link class="linkA" to="/system/blacklist">
            <div class="moduleItem">
              <div class="icon">
                <v-icon name="user-cog" scale="4"></v-icon>
              </div>
              <p>处罚管理</p>
            </div>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "vue-awesome/icons/list-alt";
import "vue-awesome/icons/university";
import "vue-awesome/icons/user-plus";
import "vue-awesome/icons/user-lock";
import "vue-awesome/icons/user-check";
import "vue-awesome/icons/sticky-note";
import "vue-awesome/icons/user-alt-slash";
import "vue-awesome/icons/file-archive";
import "vue-awesome/icons/sitemap";
import "vue-awesome/icons/clipboard-list";
import "vue-awesome/icons/users-cog";
import "vue-awesome/icons/chalkboard-teacher";
import "vue-awesome/icons/user-cog";
import "vue-awesome/icons/regular/file-alt";
import "vue-awesome/icons/check";
import "vue-awesome/icons/clipboard-check";  // file-signature
import "vue-awesome/icons/file-signature";
import "vue-awesome/icons/comment-alt"; // 提示气泡
import {tipsNum} from "@/api/system_manager/api";
import '../../assets/js/yioks-icons'
import fiveMixins from '@/minix/fiveMixins';

export default {
  name: "home",
  mixins: [fiveMixins],
  data() {
    return {
      classNum: 0,
      classScoreNum: 0,
      classApplicationNum: 0,
    };
  },
    computed: {
      noticeNum() {
        return this.$store.state.stateNoticeNum
      },
      confirmInfo(){
        return this.$store.state.confirmInfo
      },
      infoRefused(){
        return this.$store.state.infoRefused
      },
      peopleAppeal(){
        return this.$store.state.peopleAppeal
      },
      qualification(){
        return this.$store.state.qualification
      },
      punishPeople(){
        return this.$store.state.punishPeople
      },
      complaint(){
        return this.$store.state.complaint
      },
      appeal(){
        return this.$store.state.appeal
      },
      reconsider(){
        return this.$store.state.reconsider
      },
      otherComplaint(){
        return this.$store.state.otherComplaint
      }
    },
  components: {
    "v-icon": () => import("vue-awesome/components/Icon"),
  },
  filters: {
    filterNum(num) {
      return Number(num) >= 100 ? (num = "99+") : num;

    },
  },
  created() {
    tipsNum({})
    .then((res) => {
      if (Number(res.data.status) == 0) {
        this.classNum = res.data.result.class_num;
        this.classScoreNum = res.data.result.class_score_num;
        this.classApplicationNum = res.data.result.audit_application_num;
      }
    })
    .catch((err) => {
      console.error(err);
    });

  },
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/css/variable'
#home
  width 100%
  height 100%
  display flex
  justify-content center
  align-items center
  user-select none
  .homeWrap
    width 930px
    .logoTitle
      height 85px
      display flex
      flex-direction column
      justify-content center
      align-items center
      margin 0 0 40px 0
      color $color_title
      font-size 40px
      font-weight bolder
      text-shadow 2px 1px 3px #231815
    .moduleWrap
      .moduleUp, .moduleDown, .module-item
        margin 40px 0
        display flex
        justify-content space-between
        box-sizing border-box
        .linkA
          // width: 200px;
          // flex: 1 1 auto;
          flex 1
          margin 0 20px
      .moduleItem
        position relative
        width 100%
        height 200px
        display flex
        flex-direction column
        justify-content center
        align-items center
        color $color_white
        font-size 23px
        background-color $block_bg_color_base
        cursor pointer
        .icon
          display flex
          align-items center
        p
          margin 20px 0 0
          font-size 20px
      .classItem
        .tips
          position absolute
          top calc(20% - 15px)
          right calc(35% - 15px)
          .icon
            color $color_suc
          .num
            width 100%
            height 100%
            padding 2px 0 0
            position absolute
            top 0
            left 0
            text-align center
            font-size $font_size_big
.bg
  background-color $block_bg_color_base
.animate
  flex-basis 2
.h200
  height 200px
.module-item
  display flex
  .tips
    position absolute
    top calc(20% - 15px)
    right calc(35% - 15px)
    .icon
      color $color_suc
    .num
      width 100%
      height 100%
      padding 2px 0 0
      position absolute
      top 0
      left 0
      text-align center
      font-size $font_size_big
  .item-wrapper
    flex 1
    height 200px
    display flex
    .linkA
      margin 0 20px
    .hover-box-hide
      margin 0 20px
      flex 1
    .hover-box-show
      display none
    &:hover
      .hover-box-show
        display flex
        flex 1
        justify-content space-between
      .hover-box-hide
        display none
.moduleDown
  display flex
  .tips
    position absolute
    top calc(20% - 15px)
    right calc(35% - 15px)
    .icon
      color $color_suc
    .num
      width 100%
      height 100%
      padding 2px 0 0
      position absolute
      top 0
      left 0
      text-align center
      font-size $font_size_big
</style>
